import PropTypes from "prop-types";
import React from "react";

export const DollarCircle = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M 24 12  C 24 5.370873786407742  18.629126213592144 0  12 0  C 5.370873786407856 0  0 5.370873786407742  0 12  C 0 18.629126213592258  5.370873786407856 24  12 24  C 18.629126213592144 24  24 18.629126213592258  24 12  Z M 16.421359223301124 14.31844660194173  C 16.415533980582723 16.25825242718446  14.900970873786491 17.370873786407742  13.100970873786537 17.621359223300942  L 13.100970873786537 19.01941747572812  L 11.097087378640936 19.01941747572812  C 11.097087378640936 19.01941747572812  11.097087378640936 17.76699029126212  11.097087378640936 17.76699029126212  C 10.135922330097173 17.68543689320387  8.866019417475854 17.33592233009705  7.9339805825243275 16.82330097087373  C 7.9339805825243275 16.82330097087373  8.598058252427336 14.516504854368918  8.598058252427336 14.516504854368918  C 9.658252427184607 14.930097087378613  11.201941747572846 15.448543689320331  12.343689320388421 15.198058252427131  C 13.33980582524282 14.982524271844625  13.596116504854535 14.085436893203848  12.419417475728324 13.57864077669899  C 11.429126213592326 13.130097087378601  8.00970873786423 12.664077669902895  8.00970873786423 9.80970873786407  C 8.00970873786423 8.6271844660194  8.89514563106809 6.996116504854342  11.102912621359337 6.518446601941719  C 11.102912621359337 6.518446601941719  11.102912621359337 5.097087378640765  11.102912621359337 5.097087378640765  L 13.106796116504938 5.097087378640765  C 13.106796116504938 5.097087378640765  13.106796116504938 6.401941747572778  13.106796116504938 6.401941747572778  C 13.963106796116563 6.460194174757248  14.83689320388362 6.617475728155341  15.85048543689345 6.937864077669872  C 15.751456310679714 7.3805825242718015  15.314563106796186 9.297087378640754  15.314563106796186 9.297087378640754  C 14.615533980582768 9.05825242718447  13.473786407767193 8.644660194174719  12.378640776699058 8.708737864077648  C 11.027184466019435 8.784466019417437  10.928155339805926 9.774757281553377  11.84271844660202 10.229126213592224  C 13.712621359223476 11.073786407766988  16.421359223301124 11.796116504854353  16.421359223301124 14.31844660194173  Z " />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 24 24",
    };
  }
};

DollarCircle.displayName = "DollarCircleIcon";

DollarCircle.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

DollarCircle.defaultProps = { role: "img" };
